<template>
  <ValidationProvider :rules="validationRule" v-slot="{ errors, dirty, valid , classes }" tag="div" class="form-group">
    <div>
      <label :for="name" :class="classes"> {{ label }} </label>
      <input
        :name="name"
        class="form-control"
        :class="classes"
        :type="inputType"
        :placeholder="placeholder"
        :value="value"
        :disabled="disabled"
        v-mask="mask"
        @input="$emit('input', $event.target.value)"
      >
    </div>
    <ul class="errors">
      <li class="text-danger" v-for="(error,idx) in errors" :key="idx">{{ error }}</li>
    </ul>
  </ValidationProvider>
</template>

<script>
export default {
  name: 'basicMaskedInput',
  props: ['name', 'label', 'placeholder', 'value', 'inputType', 'validationRule', 'mask', 'disabled'],
  data() {
    return {
      inputValue: '',
    };
  },
  created() {
    this.inputValue = this.value;
  },
  methods: {
    handleInputChange() {
      this.$emit('inputChange', { name: this.name, value: this.inputValue });
    },
  },
};

</script>

<style scoped lang="scss">

  input.valid {
    color: #3c763d;
    border:1px solid #3c763d;
    background-color: #dff0d8;
  }

  input.invalid {
    color: #a94442;
    border:1px solid #a94442;
    background-color: #f2dede;
  }

  label {
    margin-right: 15px;
    width: auto;
    min-width: 100px;
  }
</style>
